/* unplugin-vue-components disabled */import { render } from "./MossSymbol.vue?vue&type=template&id=527fbefe&scoped=true"
import script from "./MossSymbol.vue?vue&type=script&lang=js"
export * from "./MossSymbol.vue?vue&type=script&lang=js"

import "./MossSymbol.vue?vue&type=style&index=0&id=527fbefe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527fbefe"]])

export default __exports__